import React from 'react';

import { useLanguage } from '../LanguageContext';

export default function LanguageToggle({ className }) {
  const { locale, toggleLocale, isLoading } = useLanguage();
  if (isLoading) return null;

  return (
    <button type="button" onClick={toggleLocale} className={`${className}`}>
      <svg
        className="w-4 h-4 text-wedding-nav"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5c-.39 3.013-1.892 5.922-4.001 8.286M9 9h.01M9 13H5c2.32 0 4.248-1.575 4.887-3.75"
        />
      </svg>
      {locale === 'en' ? '中' : 'EN'}
    </button>
  );
}
